export default __webpack_public_path__ + "static/media/fundamentos-comp-nuvem.92cc938b.png";